import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';

interface TestimonialProps {
  title: string;
  description: string;
  quote: string;
  authorName: string;
  authorTitle: string;
  authorImage: string;
  invert: boolean; // Para alternar la posición
}


const TestimonialSection: React.FC<TestimonialProps> = ({
  title,
  description,
  quote,
  authorName,
  authorTitle,
  authorImage,
  invert,
}) => {
  return (
    <Row className="d-flex align-items-center">
      {/* Si invert es verdadero, se invierten las columnas */}
      {!invert ? (
        <>
          <Col md={6}>
            <div>
              <span style={{ color: '#6c757d', fontSize: '0.85rem' }}>NONPROFIT</span>
              <h2 style={{ fontWeight: 'bold' }}>{title}</h2>
              <p>{description}</p>
              <a href="#" style={{ textDecoration: 'none', fontWeight: 'bold' }}>Read More</a>
            </div>
          </Col>

          <Col md={6}>
            <Card style={{ color: 'white', padding: '20px', borderRadius: '10px' }} className='card_testimonial'>
              <Card.Body>
                <Card.Text style={{ fontSize: '2rem', lineHeight: "30px" }}>
                  <i>{quote}</i>
                </Card.Text>
                <Row className="align-items-center mt-3">
                  <Col xs={3}>
                    <img
                      src={authorImage}
                      alt={authorName}
                      style={{ borderRadius: '50%', width: '100%' }}
                    />
                  </Col>
                  <Col xs={9}>
                    <h6>{authorName}</h6>
                    <p style={{ margin: 0 }}>{authorTitle}</p>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </>
      ) : (
        <>
          {/* Invertimos las columnas cuando invert es true */}
          <Col md={6}>
            <Card style={{ color: 'white', padding: '20px', borderRadius: '10px' }} className='card_testimonial'>
              <Card.Body>
                <Card.Text style={{ fontSize: '2rem', lineHeight: "30px" }}>
                  <i>{quote}</i>
                </Card.Text>
                <Row className="align-items-center mt-3">
                  <Col xs={3}>
                    <img
                      src={authorImage}
                      alt={authorName}
                      style={{ borderRadius: '50%', width: '100%' }}
                    />
                  </Col>
                  <Col xs={9}>
                    <h6>{authorName}</h6>
                    <p style={{ margin: 0 }}>{authorTitle}</p>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>

          <Col md={6}>
            <div>
              <span style={{ color: '#6c757d', fontSize: '0.85rem' }}>NONPROFIT</span>
              <h2 style={{ fontWeight: 'bold' }}>{title}</h2>
              <p>{description}</p>
              <a href="#" style={{ textDecoration: 'none', fontWeight: 'bold' }}>Read More</a>
            </div>
          </Col>
        </>
      )}
    </Row>
  );
};

export default TestimonialSection;
